const STRIPE = 'stripe';
const ASAAS = 'asaas';

export function detectProvider(plan, buyerCountry) {
  const normalizedCountry = normalizeCountry(buyerCountry);

  if (normalizedCountry === 'BR') {
    return ASAAS;
  }

  if (!normalizedCountry) {
    return ASAAS;
  }

  if (stripeAvailable(plan)) {
    return STRIPE;
  }

  return ASAAS;
}

export function isStripeProvider(provider) {
  return String(provider || '').toLowerCase() === STRIPE;
}

export function normalizeCountry(country) {
  if (!country) {
    return null;
  }

  return String(country).trim().toUpperCase();
}

// USD is offered only when the creator's Stripe catalog is live for the
// plan: an ACTIVE stripe provider mapping (WP-09 replication) is the
// authoritative signal; provider.code/currency stay as fallback for older
// product payloads.
export function stripeAvailable(plan) {
  const mappings = plan?.providerMappings || plan?.provider_mappings || [];

  if (Array.isArray(mappings) && mappings.some(isActiveStripeMapping)) {
    return true;
  }

  const providerCode = String(plan?.provider?.code || plan?.provider || '').toLowerCase();
  const currency = String(plan?.currency || '').toUpperCase();

  return providerCode === STRIPE || currency === 'USD';
}

function isActiveStripeMapping(mapping) {
  return String(mapping?.provider || '').toLowerCase() === STRIPE
    && String(mapping?.status || '').toLowerCase() === 'active';
}

// The deferred Payment Element renders BEFORE any intent exists, so the
// connected account and amount it initializes with must come from the
// product payload's active stripe mapping.
export function getStripeCatalog(plan) {
  const mappings = plan?.providerMappings || plan?.provider_mappings || [];

  if (!Array.isArray(mappings)) {
    return null;
  }

  const mapping = mappings.find(isActiveStripeMapping);

  if (!mapping) {
    return null;
  }

  const amount = Number(mapping.price_amount ?? mapping.priceAmount);

  return {
    stripeAccount: mapping.stripe_account || mapping.stripeAccount || null,
    amount: Number.isFinite(amount) && amount > 0 ? amount : null,
    currency: String(mapping.currency || 'usd').toLowerCase(),
  };
}

export const PAYMENT_PROVIDERS = {
  ASAAS,
  STRIPE,
};
